<script>
import PlanObject from '@/components/page-billing/PlanObject.vue';

export default {
    components: {
        PlanObject,
    },
    props: {
        filteredPlans: {
            type: Array,
            default: () => [],
        },
        getPlanTypeBadge: {
            type: Function,
            required: true,
        },
    },
    computed: {
        plans() {
            return this.filteredPlans || this.$store.getters.BILLING_PLANS;
        },
        isLoading() {
            return this.$store.getters.IS_PLANS_LOADING;
        },
        total() {
            return this.plans.length;
        },
    },
};
</script>

<template>
    <div class="right_container_block">
        <div class="right_header">
            <label>Subscription Plans ({{ total }}):</label>
        </div>

        <div v-if="isLoading" class="loading_container">
            <p>Loading plans...</p>
        </div>

        <div v-else-if="plans.length === 0" class="no_plans">
            <p>No subscription plans found</p>
        </div>

        <table v-else>
            <thead>
                <tr>
                    <th>ID</th>
                    <th>Status</th>
                    <th>Type</th>
                    <th>Name</th>
                    <th>Price</th>
                    <th>Period</th>
                    <th>Trial</th>
                    <th>Downloads</th>
                    <th>Subscriptions</th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                <PlanObject
                    v-for="plan in plans"
                    :key="plan.id"
                    :plan="plan"
                    :getPlanTypeBadge="getPlanTypeBadge"
                />
            </tbody>
        </table>
    </div>
</template>

<style scoped>
.right_container_block {
    padding: 20px;
}

.right_header {
    margin-bottom: 20px;
    font-size: 24px;
    font-weight: 600;
    color: var(--text-color);
}

.loading_container,
.no_plans {
    padding: 40px 20px;
    text-align: center;
    color: var(--text-color-secondary);
}

table {
    width: 100%;
    border-collapse: collapse;
}

th {
    padding: 12px 15px;
    text-align: left;
    font-weight: 600;
    color: var(--text-color);
    border-bottom: 2px solid var(--border-color);
    background: var(--background);
    position: sticky;
    top: 0;
}
</style>
